import React, { useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../constants/pagination'
import { filterActiveOptions } from '../../../../../utils/app.utils'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { MenuItem, Typography } from '@mui/material'



// COMPONENT
import InputTextField from '../../../../../component/input/inputTextField'
import FilterSelect from '../../../../../component/select/filterSelect'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

// API
import { DepartMentApi } from '../../../../../api/department/department.api'
import { RolesApi } from '../../../../../api/roles/roles.api'
import { PositionsApi } from '../../../../../api/positions/positions.api'
import { EmployeesApi, createEmployeesTypes } from '../../../../../api/employee/Employees.api';
import { swalError, swalSuccess } from '../../../../../component/notification/swal'
import { notificationSwal } from '../../../../../utils/notification.swal'
import AutocompleteSelect from '../../../../../component/select/autoCompleteSelect'
import CheckboxPermission from '../../../../../component/checkboxPermission/checkboxPermission'
import ButtonCustom from '../../../../../component/button/buttonCustom'

type Props = {
    toggleModal: () => void;
    fetchData: () => void;
}
type errorMessage = {

}
interface Action {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

interface Role {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

const AddUsers: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState<createEmployeesTypes>({
        title: "",
        employeeFirstname: "",
        employeeLastname: "",
        email: "",
        password: "",
        idRole: 0,
        idDepartment: 0,
        idPosition: 0,
        tel: "",
        fax: "",
        employeeStatus: t("STATUS.ACTIVE")
    })
    const [confirmPassword, setConfirmPassword] = useState<string>("")
    const [isShowPassword, setIsShowPassword] = useState<boolean>(false)
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState<boolean>(false)
    const [role, setRole] = useState<any>(null)
    const [department, setDepartment] = useState<any>(null)
    const [positions, setPositions] = useState<any>(null)
    const [allEmployees, setAllEmployees] = useState<any>(null)
    const [permission, setPermission] = useState<Role[]>([]);

    const handleGetEmployee = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await EmployeesApi.getAllEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    // console.log(res.data?.result?.items);
                    setAllEmployees(res.data?.result?.items)

                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetRole = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await RolesApi.getRoles(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setRole(res.data?.result?.items)
                    // if (res.data?.result?.items?.length > 0) {
                    //     setFormData((prev) => ({
                    //         ...prev, idRole: res.data?.result?.items?.find((list: any) => list?.roleStatus === t("STATUS.ACTIVE"))?.idRole
                    //     }))
                    // }
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetDepartment = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await DepartMentApi.getDepartments(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setDepartment(res.data?.result?.items)
                    // if (res.data?.result?.items?.length > 0) {
                    //     setFormData((prev) => ({
                    //         ...prev,
                    //         idDepartment: res.data?.result?.items?.find((list: any) => list?.departmentStatus === t("STATUS.ACTIVE"))?.idDepartment
                    //     }))
                    // }
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleGetPositions = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await PositionsApi.getPosition(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setPositions(res.data?.result?.items)
                    // if (res.data?.result?.items?.length > 0) {
                    //     setFormData((prev) => ({
                    //         ...prev,
                    //         idPosition: res.data?.result?.items?.find((list: any) => list?.positionStatus === t("STATUS.ACTIVE"))?.idPosition
                    //     }))
                    // }
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        try {
            // if (formData.password !== confirmPassword) {
            //     swalError(notificationSwal.password_not_match)
            // } else {
            dispatch(setLoading())
            await EmployeesApi.createEmployee({ ...formData, permission: permission })
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        swalSuccess(notificationSwal.success)
                        props.toggleModal()
                    } else {
                        swalError(res.response?.data?.description);
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                    swalError(notificationSwal.error);
                })
                .finally(() => {
                    dispatch(unsetLoading())
                    props.fetchData()
                })
            // }
        } catch (error) {
            console.log(error)
        }
    }
    const getNewRole = async (id: any) => {
        if (id) {
            RolesApi.getDetail(id).then((res) => {
                if (res?.data?.success) {
                    setPermission(res.data.result.permission)
                }
            });
        }

    }

    useEffect(() => {
        handleGetRole();
        handleGetDepartment();
        handleGetPositions();
        handleGetEmployee()
    }, [])

    const handleCheckboxChange = (node: any, checked: boolean) => {
        const updatedData = updateData([...permission], node, checked);
        setPermission(updatedData);
    };
    const updatePermit = (data: any, checked: boolean) => {
        return data?.map((item: any) => {
            const updatedItem = { ...item, permit: checked };
            if (item.actions && item.actions.length > 0) {
                updatedItem.actions = updatePermit(item.actions, checked);
            }
            return updatedItem;
        });
    };
    const updateData = (arr: any, targetNode: any, checked: boolean) => {
        return arr.map((node: any) => {
            if (node.code === targetNode.code) {
                return { ...node, permit: checked, actions: checked ? targetNode.actions : updatePermit(node.actions, false) };
            } else if (node.actions && node.actions.length > 0) {
                return { ...node, actions: updateData(node.actions, targetNode, checked) };

            }
            return node;
        });
    };
    const updateAll = (data: any) => {
        setPermission(updatePermit(data, true))
    }

    return (
        <form className='w-full' onSubmit={handleSubmit} >
            <div className='w-full flex flex-col gap-2'>
                <section className='grid grid-cols-12 gap-2 mt-5'>
                    <span className='col-span-12 md:col-span-3'>
                        <InputTextField
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, title: e.target.value })}
                            value={formData.title}
                            required
                            heading='คำนำหน้าชื่อ'
                            disabled
                        />
                    </span>
                    <span className='col-span-12 md:col-span-9'>
                        {/* <InputTextField
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, employeeFirstname: e.target.value })}
                            value={formData.employeeFirstname}
                            required
                            heading='ชื่อ - นามสกุลพนักงาน'
                        /> */}
                        <AutocompleteSelect labelId={''} heading={'ชื่อ - นามสกุลพนักงาน'} options={filterActiveOptions(allEmployees, 'employeeStatus', 'idEmployee', [(formData as any)?.idEmployee])}
                            getOptionLabel={(option) => option.employeeFirstname ? `${option.employeeFirstname} ${option.employeeLastname}` : ''}
                            value={formData || null}
                            onChange={(e: any, value: any) => {
                                setFormData({ ...value, idRole: null })
                                // setPermission(Permission)
                                // clearErrorMessage()
                            }}
                            required
                        // helperText={
                        //     errorMessage.EMPLOYEES_F_NAME || ''
                        // }
                        // disabled={mode === 'edit'}
                        />
                    </span>
                    {/* <span className='col-span-12 md:col-span-12'>
                        <InputTextField
                            value={formData.employeeLastname}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, employeeLastname: e.target.value })}
                            required
                            heading='นามสกุลพนักงาน'
                        />
                    </span> */}
                </section>
                <section className='w-full'>
                    <InputTextField
                        required
                        heading='email'
                        type='email'
                        value={formData.email}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, email: e.target.value })}
                        disabled
                    />
                </section>
                {/* <section className='grid grid-cols-12 gap-2 mt-2'>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            endAdornment={
                                <RemoveRedEyeOutlinedIcon
                                    onClick={() => setIsShowPassword(!isShowPassword)}
                                    className={`${isShowPassword ? '' : 'text-light'}`}
                                />}
                            required
                            heading='รหัสผ่าน'
                            value={formData.password}
                            type={`${isShowPassword ? 'text' : 'password'}`}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, password: e.target.value })}
                        />
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            endAdornment={
                                <RemoveRedEyeOutlinedIcon
                                    onClick={() => setIsShowConfirmPassword(!isShowConfirmPassword)}
                                    className={`${isShowConfirmPassword ? '' : 'text-light'}`}
                                />
                            }
                            type={`${isShowConfirmPassword ? 'text' : 'password'}`}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
                            required={formData.password !== confirmPassword}
                            heading='ยืนยันรหัสผ่าน'
                            helperText={formData.password === confirmPassword ? '' : "รหัสผ่านไม่ตรงกัน"}
                        />
                    </span>
                </section> */}
                <section>
                    {role && (
                        <FilterSelect
                            required
                            heading={t("บทบาท")}
                            label={t('STATUS.LABEL')}
                            selectId="select-role"
                            value={formData.idRole}
                            labelId="label-role"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setFormData({ ...formData, idRole: Number(e.target.value) })
                                getNewRole(e.target.value)
                            }}
                            options={
                                filterActiveOptions(role, 'roleStatus', 'idRole', [formData.idRole]).map((list: any) => (
                                    <MenuItem disabled={list?.roleStatus !== t("STATUS.ACTIVE")} key={list?.idRole} value={list?.idRole}>
                                        {list?.roleName}
                                    </MenuItem>
                                ))
                            }
                        />
                    )}
                </section>
                <section>
                    {department && (
                        <FilterSelect
                            disabled
                            required
                            heading={t("หน่วยงาน")}
                            label={t('STATUS.LABEL')}
                            selectId="select-department"
                            value={formData.idDepartment}
                            labelId="label-department"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, idDepartment: Number(e.target.value) })}
                            options={
                                department.map((list: any) => (
                                    <MenuItem disabled={list?.departmentStatus !== t("STATUS.ACTIVE")} key={list?.idDepartment} value={list?.idDepartment}>
                                        {list?.departmentName}
                                    </MenuItem>
                                ))
                            }
                        />
                    )}
                </section>
                <section>
                    {positions && (
                        <FilterSelect
                            disabled
                            required
                            heading={t("ตำแหน่ง")}
                            label={t('STATUS.LABEL')}
                            selectId="select-position"
                            value={formData.idPosition}
                            labelId="label-position"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setFormData({ ...formData, idPosition: Number(e.target.value) })}
                            options={
                                positions.map((list: any) => (
                                    <MenuItem disabled={list?.positionStatus !== t("STATUS.ACTIVE")} key={list?.idPosition} value={list?.idPosition}>
                                        {list?.positionName}
                                    </MenuItem>
                                ))
                            }
                        />
                    )}
                </section>
                <section className='grid grid-cols-12 gap-2 mt-2'>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            required
                            heading='โทรศัพท์'
                            value={formData.tel}
                            type='text'
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, tel: e.target.value })}
                            disabled
                        />
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <InputTextField
                            required
                            heading='โทรสาร'
                            value={formData.fax}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, tel: e.target.value })}
                            disabled
                        />
                    </span>
                </section>
                {permission?.length > 0 &&
                    <>
                        <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>{'กำหนดฟังก์ชัน'}</Typography>
                        <ButtonCustom textButton={'เลือกทั้งหมด'} onClick={() => updateAll(permission)} />
                    </>
                }
                {permission && permission?.map((list: any) => (
                    <CheckboxPermission
                        node={list}
                        onCheckboxChange={handleCheckboxChange}
                    />
                ))}
                <section className='flex justify-center items-center mt-3'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 100 }}
                    >
                        {t("BUTTON.SAVE")}
                    </ButtonContained>
                </section>
            </div>
        </form>
    )
}

export default AddUsers